import BlPermissionDialogMv from './BlPermissionDialogMv.vue'

BlPermissionDialogMv.install = function(Vue) {
  Vue.component(BlPermissionDialogMv.name, BlPermissionDialogMv)
}

export default BlPermissionDialogMv
